import script from "./ClaimVested.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaimVested.vue?vue&type=script&setup=true&lang=js"

import "./ClaimVested.vue?vue&type=style&index=0&id=44bb2540&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44bb2540"]])

export default __exports__